import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LocationStrategy } from '@angular/common';
import { HashPreserveQueryLocationStrategy } from './pages/testcase/custom-routing';
import { InfoPageComponent } from './pages/info-page/info-page.component';
import { BirthdayCheckComponent } from './pages/birthday-check/birthday-check.component';
import { WithdrawalComponent } from './pages/withdrawal/withdrawal.component';
import { PagesGuard } from './share/guard/pages.guard';
import { TestcaseComponent } from './pages/testcase/testcase.component';

import { OfferDetailsComponent } from './pages/resultpage/offer/offer-details/offer-details.component';
import { AppWrapperComponent } from './pages/app-wrapper/app-wrapper.component';
import { testGuard } from './share/guard/test.guard';
import { ActiveComponent } from './pages/active/active.component';
import { ArchiveComponent } from './pages/archive/archive.component';

const routes: Routes = [
  {
    path: '',
    component: AppWrapperComponent,
    canActivate: [PagesGuard],
  },
  { path: 'test', component: TestcaseComponent, canActivate: [testGuard] },
  { path: 'info', component: InfoPageComponent },
  { path: 'active', component: ActiveComponent, canActivate: [PagesGuard] },
  { path: 'archive', component: ArchiveComponent, canActivate: [PagesGuard] },
  { path: 'birthdaycheck', component: BirthdayCheckComponent },
  { path: 'withdrawal', component: WithdrawalComponent },
  {
    path: 'offer/:offerId',
    component: OfferDetailsComponent,
    canActivate: [PagesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [
    { provide: LocationStrategy, useClass: HashPreserveQueryLocationStrategy },
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
